// Copyright 1999-2017. Plesk International GmbH. All rights reserved.
/* eslint-disable react/no-danger */

import { createElement } from '../../utils';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import marked from 'marked';
import { CLS_PREFIX } from '../../constants';

import './Markdown.less';

/**
 * Markdown component.
 */
const Markdown = ({ baseClassName, className, compact = false, children }) => (
    <div
        className={classNames(
            baseClassName,
            {
                [`${baseClassName}--compact`]: compact,
            },
            className,
        )}
        dangerouslySetInnerHTML={{ __html: marked(children, { sanitize: true }) }}
    />
);

Markdown.propTypes = {
    /**
     * Content of the Markdown
     */
    children: PropTypes.string.isRequired,
    /**
     * Compact mode
     */
    compact: PropTypes.bool,
    /**
     * @ignore
     */
    className: PropTypes.string,
    /**
     * @ignore
     */
    baseClassName: PropTypes.string,
};

Markdown.defaultProps = {
    compact: false,
    className: null,
    baseClassName: `${CLS_PREFIX}markdown`,
};

export default Markdown;



// WEBPACK FOOTER //
// ./components/Markdown/Markdown.js